import script from "./MyDoubleRange.vue?vue&type=script&setup=true&lang=ts"
export * from "./MyDoubleRange.vue?vue&type=script&setup=true&lang=ts"

import "./MyDoubleRange.vue?vue&type=style&index=0&id=18def2eb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18def2eb"]])

export default __exports__